import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiAlertComponent, QaiButtonComponent } from '@qai/ui';

@Component({
  imports: [CommonModule, QaiAlertComponent, QaiButtonComponent, TranslocoModule],
  selector: 'app-call-hint-tour',
  standalone: true,
  styleUrls: ['./call-hint-tour.css'],
  templateUrl: './call-hint-tour.html',
})
export class CallHintTourComponent {
  @Output() readonly continueTourClicked = new EventEmitter();

  protected handleContinueTourClick() {
    this.continueTourClicked.emit();
  }
}
